import React from "react";
import SquarePreview from "../squarePreview/squarePreview";
import { productLink } from "../../utils/resolveProductFamily";

const ProductPreview = (props) => {
  const {
    title,
    body,
    image,
    uuid,
    animated,
    square,
    label,
    disable_documentation,
  } = props;

  // Current products link to their version-less family page, deprecated ones to their own
  const link = props.alias
    ? productLink(props.alias, props.deprecated)
    : `/apiProduct/${uuid || props.id}`;
  const alias = link.substring("/apiProduct/".length);
  return (
    <SquarePreview
      id={alias}
      label={label}
      animated={animated}
      square={square}
      title={title}
      description={body}
      primaryButton={link}
      // Product-level documentation view (lists the product's API endpoints). The previous
      // `/documentation/${alias}` target is an API endpoint alias route and only worked when an
      // endpoint happened to share the product slug (7 of 241 products).
      secondaryButton={`/apiProduct/${alias}/documentation`}
      image={image}
      primaryButtonTitle="LEARN MORE"
      disable_documentation={disable_documentation}
    />
  );
};

export default ProductPreview;
